import { Box, Typography } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

import {
  CustomButton,
  CustomTextField,
  DrawerFormSection,
} from '../../../../common/components';
import { CURRENCY_OPTIONS } from '../../constants/supplierLedgerConstants';
import { formatCurrencyAmount } from '../../utils/supplierLedgerFormatters';
import {
  AmountLineRow,
  AmountPanel,
  FieldSelect,
  summaryControlSx,
  summaryInputSx,
} from '../SupplierLedgerShared';

const SupplierInvoiceAmountsSection = ({
  amountLines,
  amountTotals,
  form,
  locksFinancialFields,
  onAddAmountLine,
  onAmountLineChange,
  onChange,
  onRemoveAmountLine,
}) => (
  <DrawerFormSection
    title="Importes"
    action={(
      <CustomButton
        variant="outlined"
        startIcon={<AddIcon />}
        onClick={onAddAmountLine}
        disabled={locksFinancialFields}
        sx={{ height: 40, px: 2, fontSize: '0.9rem' }}
      >
        Agregar importe
      </CustomButton>
    )}
    grid={false}
  >
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25, minWidth: 0 }}>
      <Box sx={{ minWidth: 0, display: 'flex', flexDirection: 'column', gap: 1.25 }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: form.currency === 'USD' ? '150px 170px minmax(0, 1fr)' : '150px minmax(0, 1fr)',
            },
            gap: 1.25,
            alignItems: 'start',
          }}
        >
          <FieldSelect
            label="Moneda"
            name="currency"
            value={form.currency}
            onChange={onChange}
            options={CURRENCY_OPTIONS}
            sx={{ width: '100%', pointerEvents: locksFinancialFields ? 'none' : 'auto', opacity: locksFinancialFields ? 0.65 : 1 }}
          />
          {form.currency === 'USD' && (
            <CustomTextField
              label="Cotización ARS"
              name="exchange_rate_to_ars"
              value={form.exchange_rate_to_ars}
              onChange={onChange}
              disabled={locksFinancialFields}
            />
          )}
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, minWidth: 0 }}>
          {amountLines.map((line, index) => (
            <AmountLineRow
              key={line.id}
              line={line}
              index={index}
              currency={form.currency}
              canRemove={amountLines.length > 1}
              disabled={locksFinancialFields}
              onChange={onAmountLineChange}
              onRemove={onRemoveAmountLine}
            />
          ))}
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          minWidth: 0,
          p: 1.25,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          backgroundColor: 'background.paper',
        }}
      >
        <Typography variant="subtitle2" sx={{ color: 'primary.main', fontWeight: 800 }}>
          Resumen
        </Typography>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(2, minmax(0, 1fr))',
              lg: 'repeat(3, minmax(0, 1fr))',
            },
            gap: 1.25,
            minWidth: 0,
          }}
        >
          <AmountPanel
            label="Subtotal importes"
            value={formatCurrencyAmount(amountTotals.gross, form.currency)}
            sx={summaryControlSx}
          />
          <CustomTextField
            label="Perc. IVA"
            name="vat_perception_amount"
            value={form.vat_perception_amount}
            onChange={onChange}
            disabled={locksFinancialFields}
            sx={summaryInputSx}
          />
          <CustomTextField
            label="Perc. IIBB"
            name="gross_income_perception_amount"
            value={form.gross_income_perception_amount}
            onChange={onChange}
            disabled={locksFinancialFields}
            sx={summaryInputSx}
          />
          <AmountPanel
            label="Total factura"
            value={formatCurrencyAmount(amountTotals.total, form.currency)}
            sx={summaryControlSx}
          />
          <AmountPanel
            label="Neto acumulado"
            value={formatCurrencyAmount(amountTotals.net, form.currency)}
            sx={summaryControlSx}
          />
          <AmountPanel
            label="IVA acumulado"
            value={formatCurrencyAmount(amountTotals.vat, form.currency)}
            sx={summaryControlSx}
          />
        </Box>
      </Box>
    </Box>
  </DrawerFormSection>
);

export default SupplierInvoiceAmountsSection;
